"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('./AVNURAH2.cjs');


var _CTBYSXNUcjs = require('./CTBYSXNU.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/select/select-arrow.tsx
var TagName = "span";
var useSelectArrow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectArrow2({ store, ...props }) {
    const context = _AVNURAH2cjs.useSelectContext.call(void 0, );
    store = store || context;
    props = _CTBYSXNUcjs.usePopoverDisclosureArrow.call(void 0, { store, ...props });
    return props;
  }
);
var SelectArrow = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectArrow2(props) {
  const htmlProps = useSelectArrow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useSelectArrow = useSelectArrow; exports.SelectArrow = SelectArrow;
